import { Pipe, PipeTransform } from '@angular/core';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { Utils } from 'src/app/utils.class';

@Pipe({
    name: 'entityIsNight',
    standalone: false,
})
export class EntityIsNightPipe implements PipeTransform {
    transform(day: Date, planningHasEntity: PlanningHasEntity[]): unknown {
        return planningHasEntity?.filter(up => Utils.isNight(up.begindate, up.enddate))?.length;
    }
}
